import React from 'react'

import ArrowRight from '../../../../assets/images/arrow-right.svg'

import './Styles.css'

const ReportCard = ({ report, onClick = (val) => val }) => {
  const { title, path, icon } = report

  return (
    <div className={`report-card ${!path ? 'inactive' : ''}`} onClick={() => path && onClick(report)}>
      <img className="report-image" src={icon} alt={title} />
      <div className="content">
        <p className="report-title">{title}</p>
      </div>
      <img className="arrow-right" src={ArrowRight} alt="arrow-right" />
    </div>
  )
}

export default ReportCard
